<template lang="html">
  <span class='floorplan-favourite-toggle d-flex align-items-center'
  @click.prevent.stop="canToggle()">
    <i class="fal fa-star" v-if="!floorplan.favourited"></i>
    <i class="fas fa-star " v-if="floorplan.favourited"></i>
    <span v-if="!hideName" v-html="floorplan.name" class="fp-name ml-1" />
  </span>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { create } from 'vue-modal-dialogs';
import AnalyticsTracking from '@/analytics/tracking';
import BasicDialog from '@/components/Dialogs/BasicDialog';

const dialog = create(BasicDialog, 'content');

export default {
  name: 'floorplan-favourite-toggle',
  props: {
    floorplan: {
      type: Object,
      default: () => {}
    },
    hideName: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      showFavourites: state => state.floorplans.showFavourites,
    }),
    ...mapGetters({
      favouritedCount: 'floorplans/favouritedCount',
      deviceMd: 'ui/deviceMd'
    })
  },
  methods: {
    ...mapActions({
      toggleFavourited: 'floorplans/toggleFloorplanFavourited'
    }),
    canToggle() {
      if (this.showFavourites && this.floorplan.favourited
      && this.$route.name === 'FloorplanDetail') {
        this.modalOpen = true;
        dialog('Can\'t unfavourite floorplan here.');
      } else {
        this.toggleFavourited(this.floorplan.id);
        let toastPosition = 'bottom-right';
        if (!this.deviceMd) {
          toastPosition = 'top-center';
        }
        if (this.floorplan.favourited) {
          this.$toasted.show(`Added ${this.floorplan.name} to favourites.`, {
            theme: 'favourite',
            position: toastPosition,
            duration: 3000,
            type: 'success'
          });
          AnalyticsTracking.favouritedFloorplan(this.floorplan);
        } else {
          this.$toasted.show(`Removed ${this.floorplan.name} to favourites.`, {
            theme: 'favourite',
            position: toastPosition,
            duration: 3000,
            type: 'success'
          });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.floorplan-favourite-toggle {
  cursor: pointer;
  text-transform: uppercase;
  font-family: Scandia-Medium, sans-serif;
  color: black;

  &:hover, .fa-star {
    color: var(--favourite);
  }

  &.invisible {
    visibility: hidden;
  }

  .fp-name {
    padding-top: 5px;
    font-size: 1.2rem;
  }

  .fa-star {
    // font-size: 1;
    font-size: 1.2rem;
    margin-right: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Floorplan/FloorplanFavouriteToggle.vue